"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnavailabilityModal = void 0;
const ac_1 = require("@app/ac");
const ui_1 = require("@app/component/ui");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const is_admin_1 = require("@app/util/hooks/is-admin");
const use_plugin_1 = require("@app/util/hooks/use-plugin");
const use_modal_1 = require("@app/util/modal/use-modal");
const react_1 = __importStar(require("react"));
const unav_dev_view_section_1 = require("./components/unav-dev-view-section");
const unav_extra_header_buttons_1 = require("./components/unav-extra-header-buttons");
const unav_footer_1 = require("./components/unav-footer");
const unav_header_1 = require("./components/unav-header");
const unav_overview_section_1 = require("./components/unav-overview-section");
const unav_sidebar_1 = require("./components/unav-sidebar");
const unav_stats_section_1 = require("./components/unav-stats-section");
const unavailability_context_1 = require("./unavailability-context");
const UnavailabilityModal = ({ initialData, isEmployeeCalendar, afterSubmit }) => {
    const isAdmin = (0, is_admin_1.useIsAdmin)();
    const { isPluginEnabled } = (0, use_plugin_1.usePlugin)();
    const { closeModal } = (0, use_modal_1.useModal)();
    const dispatch = (0, store_1.useRootDispatch)();
    (0, react_1.useEffect)(() => {
        const handleKeypress = (evt) => {
            // only trigger if not focused in input/textarea/contenteditable and no text is selected
            const active = document.activeElement;
            const isInput = active &&
                (['INPUT', 'TEXTAREA', 'SELECT'].includes(active.tagName) ||
                    active.isContentEditable);
            const hasSelection = window.getSelection()?.toString().length ||
                (active instanceof HTMLInputElement || active instanceof HTMLTextAreaElement
                    ? active.selectionStart !== active.selectionEnd
                    : false);
            if (isInput || hasSelection)
                return;
            // Ctrl+C
            if ((evt.ctrlKey || evt.metaKey) && evt.keyCode === 67) {
                if (util_1.multiSelectUtil
                    .getMultiSelectAllowedActionTypes(isPluginEnabled)
                    .some((a) => a.type === 'copy')) {
                    closeModal();
                    util_1.notification.success({ code: 'eventCopied', message: undefined });
                    void dispatch((0, ac_1.setCalendarMultiSelect)({
                        action: 'copy',
                        isSelectingTargets: true,
                        targets: [],
                    }));
                }
            }
        };
        document.addEventListener('keydown', handleKeypress, false);
        return () => {
            document.removeEventListener('keydown', handleKeypress, false);
        };
    }, []);
    return (react_1.default.createElement(unavailability_context_1.UnavailabilityProvider, { initialData: initialData, isEmployeeCalendar: isEmployeeCalendar, afterSubmit: afterSubmit }, ({ selectedTab, initialLoad }) => (react_1.default.createElement(ui_1.Modal, { size: 'size-l', headerContent: react_1.default.createElement(unav_header_1.UnavHeader, { isEdit: (0, util_1.isDefined)(initialData.id) }), sidebarContent: initialLoad ? null : react_1.default.createElement(unav_sidebar_1.UnavSidebar, null), footerContent: initialLoad ? null : react_1.default.createElement(unav_footer_1.UnavFooter, null), extraHeaderButtons: [
            react_1.default.createElement(unav_extra_header_buttons_1.UnavExtraHeaderButtons, { key: 'unav-extra-header-buttons' }),
        ] },
        react_1.default.createElement("div", { style: {
                width: '100%',
                height: '100%',
                padding: '1rem',
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box',
            } }, initialLoad ? (react_1.default.createElement(ui_1.Loader, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
            selectedTab === 'overview' && react_1.default.createElement(unav_overview_section_1.UnavOverviewSection, null),
            selectedTab === 'statistics' && react_1.default.createElement(unav_stats_section_1.UnavStatsSection, null),
            selectedTab === 'dev-view' && isAdmin && react_1.default.createElement(unav_dev_view_section_1.UnavDevViewSection, null))))))));
};
exports.UnavailabilityModal = UnavailabilityModal;
